import { useMutation } from '@tanstack/react-query'

import { intentionApi } from '../api/intentionApi'

export const useCreateUpliftMutation = ({
  intentionId,
  prayerId,
  onSuccess,
}: {
  intentionId: number
  prayerId: number
  onSuccess?: () => void
}) =>
  useMutation({
    mutationKey: ['create_uplift', intentionId, prayerId],
    mutationFn: (message: string) =>
      intentionApi.createUplift({ message, intention: { id: intentionId }, prayer: { id: prayerId } }),
    onSuccess,
  })
